(ns common.schema.entities.account.schema
  (:require
   [common.schema.entities.account.options :as options]
   [common.schema.schema-utils :as su]))

(defn- system-controlled
  [opts]
  (assoc opts :system-semantics su/system-controlled-optional-field-semantics))

(def schema
  (vec
   (concat
    (su/email-field :account/email
                    "Email"
                    (system-controlled {:authorization su/access-system-ssg}))
    (su/email-field :account/alt-email
                    "Alternative email"
                    (system-controlled {:authorization su/access-system-ssg}))
    (su/email-field :account/tertiary-email
                    "Tertiary email"
                    (system-controlled {:authorization su/access-system-ssg}))
    (su/text-simple-field :account/first-name
                          "First name"
                          (system-controlled {:authorization su/access-system-ssg}))
    (su/text-simple-field :account/last-name
                          "Last name"
                          (system-controlled {:authorization su/access-system-ssg}))
    (su/text-simple-field :account/phone-number
                          "Phone number"
                          (system-controlled {:authorization su/access-system-ssg}))
    (su/text-simple-field :account/picture-url
                          "Picture"
                          (system-controlled {:authorization su/access-system-ssg}))
    (su/text-edn-field :account/preferences "Preferences" {:authorization su/access-system-owner})
    (su/boolean-field :account/reminder-emails?
                      "Send reminder emails?"
                      {:authorization su/access-system-user})
    (su/text-edn-field :account/view-config "View config" {:authorization su/access-system-owner})

;; Nylas related

    (su/multi-ref-field
     :account/nylas-grants
     "Linked Nylas accounts"
     [:entity.type/nylas-account]
     {:authorization    su/access-user-user
      :system-semantics su/system-controlled-optional-field-semantics})

    (su/keyword-field :account/default-nylas-privacy
                      "Nylas privacy"
                      options/nylas-privacy-options
                      {:authorization su/access-system-owner})
    (su/text-simple-field :account/nylas-account-id
                          "Nylas account ID"
                          {:authorization    su/access-system-owner
                           :system-semantics su/system-controlled-optional-field-semantics})
    (su/email-field :account/nylas-email
                    "Nylas email address"
                    {:authorization    su/access-system-owner
                     :system-semantics su/system-controlled-optional-field-semantics})
    (su/keyword-field :account/nylas-status
                      "Nylas status"
                      options/nylas-status-options
                      {:authorization    su/access-system-user
                       :system-semantics su/system-controlled-optional-field-semantics})
    (su/boolean-field :account/nylas-sync-contacts?
                      "Sync nylas contacts?"
                      {:authorization su/access-system-user})
    (su/integer-field :account/nylas-nof-contacts-created
                      "Number of contacts created"
                      {:authorization    su/access-user-user
                       :system-semantics su/system-controlled-optional-field-semantics})
    (su/integer-field :account/nylas-initial-sync-started-on
                      "Initial sync started on"
                      {:authorization    su/access-system-user
                       :system-semantics su/system-controlled-optional-field-semantics})
    (su/integer-field :account/nylas-initial-sync-completed-on
                      "Initial sync completed on"
                      {:authorization    su/access-system-user
                       :system-semantics su/system-controlled-optional-field-semantics})

      ;; System write fields
    (su/boolean-field :account/account-initialized?
                      "Initialized"
                      {:authorization    su/access-system-owner
                       :system-semantics su/system-controlled-optional-field-semantics})
    ;; `:no-history?`: the whole string is written again for each change of the
    ;; permissions, and the old copies filled the database history (DEV-8258).
    ;; An `as-of` read of this attribute can return nothing or an old value, so
    ;; a reader of a snapshot must take it from the live db: see
    ;; `backend.search.queries/live-account-permissions`.
    (su/text-edn-field :account/current-permissions
                       "Current permissions"
                       {:authorization su/access-system-owner
                        :excluded-from-index? true
                        :no-history? true
                        :system-semantics su/system-controlled-optional-field-semantics})
    (su/text-edn-field :account/terms-accepted
                       "Terms accepted"
                       {:authorization    su/access-system-owner
                        :system-semantics su/system-controlled-not-clearable-field-semantics})
    (su/integer-field :account/kpi-ad-seen-on
                      "KPI ad seen on"
                      {:authorization    su/access-system-user
                       :system-semantics su/system-controlled-optional-field-semantics})
    (su/keyword-field :account/mfa-status
                      "MFA status"
                      options/mfa-status-options
                      {:authorization    su/access-system-authenticated
                       :system-semantics su/system-controlled-optional-field-semantics})
    (su/keyword-field :account/sys-admin-mfa-status
                      "Sys-admin MFA status"
                      options/mfa-status-options
                      {:authorization    su/access-system-authenticated
                       :system-semantics su/system-controlled-optional-field-semantics})
    (su/text-simple-field :account/sys-admin-secret-key
                          "Sys-admin secret key"
                          {:authorization    su/access-system-system
                           :system-semantics su/system-controlled-optional-field-semantics})
    (su/boolean-field :account/sys-admin? "Sys-admin?" {:authorization    su/access-system-sys-admin
                                                        :system-semantics su/system-controlled-optional-field-semantics})
    (su/boolean-field :account/zadmin? "Zadmin?" {:authorization    su/access-system-zadmin
                                                  :system-semantics su/system-controlled-optional-field-semantics})

      ;; System only fields
    (su/integer-field :account/authentication-2fa-brute-force-counter
                      "2FA brute force counter"
                      {:authorization    su/access-system-system
                       :system-semantics su/system-controlled-optional-field-semantics})
    (su/text-simple-field :account/authentication-2fa-secret-key
                          "2FA Secret key"
                          {:authorization    su/access-system-system
                           :system-semantics su/system-controlled-optional-field-semantics})
    (su/boolean-field :account/send-instructional-email?
                      "Send instructional email"
                      {:authorization    su/access-system-system
                       :system-semantics su/system-controlled-optional-field-semantics})
    (su/keyword-field :account/team-role
                      "Onboarding team role"
                      options/onboarding-team-role-options
                      {:authorization    su/access-system-system
                       :system-semantics su/system-controlled-optional-field-semantics})
    (su/keyword-multi-field :account/additional-responsibilities
                            "Additional responsibilities"
                            options/responsibility-options
                            {:authorization    su/access-system-system
                             :system-semantics su/system-controlled-optional-field-semantics})
    (su/text-simple-field :account/system "System" {:authorization    su/access-system-system
                                                    :system-semantics su/system-controlled-optional-field-semantics})
    (su/text-simple-field :account/analytics-user-id
                          "Analytics user id"
                          {:authorization    su/access-system-system
                           :no-history?      true
                           :system-semantics su/system-controlled-optional-field-semantics})

      ;; deprecated - TODO: cleanup https://zapflow.atlassian.net/browse/DEV-4274
    (su/keyword-field :account/authentication-setting
                      "Auth setting"
                      nil
                      {:authorization    su/access-system-system
                       :system-semantics su/system-controlled-optional-field-semantics})
    (su/boolean-field :account/avatar-selected?
                      "Avatar selected?"
                      {:authorization    su/access-system-system
                       :system-semantics su/system-controlled-optional-field-semantics})
    (su/boolean-field :account/created-a-deal?
                      "Created a deal?"
                      {:authorization    su/access-system-system
                       :system-semantics su/system-controlled-optional-field-semantics})
    (su/boolean-field :account/do-onboarding?
                      "Do on-boarding?"
                      {:authorization    su/access-system-system
                       :system-semantics su/system-controlled-optional-field-semantics})
    (su/boolean-field :account/seen-pr-report?
                      "Seen PR report?"
                      {:authorization    su/access-system-system
                       :system-semantics su/system-controlled-optional-field-semantics})
    (su/boolean-field :account/seen-pr-spinner?
                      "Seen PR spinner?"
                      {:authorization    su/access-system-system
                       :system-semantics su/system-controlled-optional-field-semantics})
    (su/multi-ref-field :account/authentications
                        "Deprecated authenticators refs"
                        [:entity.type/authentication]
                        {:authorization    su/access-system-system
                         :system-semantics su/system-controlled-optional-field-semantics})

      ;; TBD - these fields have been created but implementation missing
    (su/boolean-field :account/whitelist-password-login
                      "Can login with password/username"
                      {:authorization su/access-system-user})
    (su/integer-field :account/permissions-updated-on
                      "Permissions updated on"
                      {:authorization    su/access-system-ssg
                       :no-history?      true
                       :system-semantics su/system-controlled-optional-field-semantics})
    (su/multi-ref-field :account/flagged-entities
                        "List of entities that are flagged by the user"
                        [:entity.type/account]
                        {:authorization su/access-user-user
                         :default-field-visibility :in-use})
    (su/datetime-field :account/activated-on
                       "Activated on"
                       {:authorization    su/access-system-system
                        :system-semantics su/system-controlled-optional-field-semantics})
    (su/datetime-field :account/activation-reminder-sent-on
                       "Activation reminder sent on"
                       {:authorization    su/access-system-system
                        :system-semantics su/system-controlled-optional-field-semantics})

    (su/keyword-field :account/web-session-timeout-kw
                      "Web session timeout preference"
                      nil  ;; options provided by common.session-timeout/timeout-options
                      {:authorization su/access-system-owner})
    (su/keyword-field :account/addin-session-timeout-kw
                      "Add-in session timeout preference"
                      nil  ;; options provided by common.session-timeout/timeout-options
                      {:authorization su/access-system-owner}))))
